import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const FounderNote = () => {
  return (
    <section className="bg-brand-warm-50 py-10 md:py-14 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="bg-card border border-border rounded-2xl shadow-sm overflow-hidden grid md:grid-cols-[260px_1fr] items-stretch">
          <div className="bg-brand-warm-100/40 flex items-center justify-center p-8 md:p-10">
            <img
              src="/lovable-uploads/518c95f7-db9f-4da6-800d-f256729628c0.png"
              alt="Cynthia Diaz, Founder of REALV3"
              className="w-36 h-36 md:w-44 md:h-44 rounded-full object-cover border-2 border-border shadow-sm"
            />
          </div>
          <div className="p-8 md:p-10 space-y-4">
            <span className="text-xs font-medium uppercase tracking-wider text-primary">A note from our founder</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground leading-tight">
              "I built REALV3 to help people <span className="text-primary">buy and sell homes without a middleman.</span>"
            </h2>
            <div className="space-y-3 text-muted-foreground leading-relaxed">
              <p>
                I'm Cynthia. We built the real estate system to replace the old real estate market where you used to rely on an agent.
              </p>
              <p>
                We're going back to 1908 where it started — and fixing the problem.
              </p>
              <p>
                We believe in buying a home with no pressure, in control, and no salesman breathing down your neck. Visit as many homes as you want before you decide to offer. No fake urgency, no "three other offers" stories — you see exactly what is real on every listing.
              </p>
              <p>
                For sellers, you keep your equity instead of handing it to a middleman. You post, we push your listing across our network, and our Listing Concierge handles the rest. We built REALV3 for homeowners on tight equity who are stuck because the old system costs too much to sell.
              </p>
            </div>
            <div className="pt-2 flex items-center gap-4">
              <p className="font-display text-lg text-foreground italic">— Cynthia Diaz</p>
              <Link to="/about">
                <Button variant="outline" size="sm">Read the full story</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderNote;
